import es from './es_ES/translations.js';
import en from './en_GB/translations.js';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from 'BRAND/config';

const KEY_LOCALE = 'locale';
const DEFAULT_LOCALE = config.locale;
const FALLBACK_LOCALE = config.locale;

const saveToLocalStorage = (lang) => {
  localStorage.setItem(KEY_LOCALE, lang);
};

const loadFromLocalStorage = () => {
  const locale = localStorage.getItem(KEY_LOCALE);
  return (locale) || DEFAULT_LOCALE;
};

Vue.use(VueI18n);

const i18nConfig = {
  locale: loadFromLocalStorage(),
  fallbackLocale: FALLBACK_LOCALE,
  silentTranslationWarn: true,
  messages: {
    es_ES: {...es, ...(config.i18n === undefined ? {} : config.i18n.es_ES)},
    en_GB: {...en, ...(config.i18n === undefined ? {} : config.i18n.en_GB)}
  }
};

export default {
  config: new VueI18n(i18nConfig),
  save: saveToLocalStorage,
  load: loadFromLocalStorage
};



// WEBPACK FOOTER //
// ./src/i18n/index.js